<template>
  <v-card rounded="xl">
    <v-card-text>
      <div class="title font-weight-bold d-flex justify-center pa-4" color="text--primary">{{ name }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["name"],
  data: () => ({
    memberName: "",
  }),

  methods: {
    handleSubmit() {
      console.log(this.memberName);
    },
  },
};
</script>

<style lang="scss" scoped></style>
